import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { Data } from '@/types';

import { getCsrfToken } from './getCsrfToken';

export type RegistrationDTO = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
  accepted: boolean;
};

export const register = async (data: RegistrationDTO): Promise<Data<any>> => {
  await getCsrfToken();
  return axios.post(`${API_BASE_PATH}/register`, data);
};
